import request from "superagent";

export const GET_PRE_LOGIN_FEATURES = "featureFlags/GET_PRE_LOGIN_FEATURES";
export const GET_PRE_LOGIN_FEATURES_DATA_RECEIVED =
  "featureFlags/GET_PRE_LOGIN_FEATURES_DATA_RECEIVED";
export const GET_PRE_LOGIN_FEATURES_ERROR =
  "featureFlags/GET_PRE_LOGIN_FEATURES_ERROR";

export const GET_POST_LOGIN_FEATURES = "featureFlags/GET_POST_LOGIN_FEATURES";
export const GET_POST_LOGIN_FEATURES_DATA_RECEIVED =
  "featureFlags/GET_POST_LOGIN_FEATURES_DATA_RECEIVED";
export const GET_POST_LOGIN_FEATURES_ERROR =
  "featureFlags/GET_POST_LOGIN_FEATURES_ERROR";

export default function featureFlagsServiceFactory(store, next, action) {
  return {
    [GET_PRE_LOGIN_FEATURES]: () => {
      request.get("/api/public/featureFlags/preLogin").end((err, res) => {
        if (err) {
          return next({
            type: GET_PRE_LOGIN_FEATURES_ERROR,
            err
          });
        }

        const data = res.body;

        return next({
          type: GET_PRE_LOGIN_FEATURES_DATA_RECEIVED,
          data
        });
      });
    },
    [GET_POST_LOGIN_FEATURES]: () => {
      request
        .get("/api/featureFlags/postLogin?username=" + action.username)
        .end((err, res) => {
          if (err) {
            return next({
              type: GET_POST_LOGIN_FEATURES_ERROR,
              err
            });
          }

          const data = res.body;

          return next({
            type: GET_POST_LOGIN_FEATURES_DATA_RECEIVED,
            data
          });
        });
    }
  };
}



// WEBPACK FOOTER //
// ./src/services/featureFlags/index.js